module.exports = __webpack_public_path__ + "static/media/Albert.f9dec2df.png";